<div class="toast-container position-absolute top-0 end-0">
  <div *ngFor="let notification of notifications">

    <div class="toast show mt-3 me-3" style="background-color: white;" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <i class="bi me-1" [ngClass]="getIcon(notification.type)" [attr.style]="'color:' + getColor(notification.type)"></i>
        <strong class="me-auto">{{notification.title}}</strong>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"
          (click)="close(notification)"></button>
      </div>
      <div class="toast-body">
        <p>{{notification.message}}</p>
      </div>
    </div>
    
  </div>
</div>